import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { logger } from 'utils/logger';
import { bulkAllowEditWhiteboard } from 'features/permissions/actions';

export function* bulkAllowEditWhiteboardSaga(action: ReturnType<typeof bulkAllowEditWhiteboard>) {
  const { roles } = action.payload;

  logger
    .remote({ action: true, tier: 1 })
    .info(`The user bulk allowed edit whiteboard for roles=${roles.join(',')}`);

  yield call(SignalingSocket.send, {
    event: 'bulkAllowEditWhiteboard',
    data: { roles },
  });
}
